'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReadMore = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _shortenText = require('helpers/shortenText');

var _shortenText2 = _interopRequireDefault(_shortenText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReadMore = exports.ReadMore = function (_React$Component) {
  (0, _inherits3.default)(ReadMore, _React$Component);

  function ReadMore(props) {
    var _this, _this2;

    (0, _classCallCheck3.default)(this, ReadMore);

    _this = (_this2 = (0, _possibleConstructorReturn3.default)(this, (ReadMore.__proto__ || (0, _getPrototypeOf2.default)(ReadMore)).call(this, props)), _this2);

    _this2.handleContentChange = function (content) {
      var shortened = (0, _shortenText2.default)(content, _this.props.maximumSummaryLength);
      if (content !== shortened) {
        _this.setState({ expanded: false, content: shortened });
      } else {
        _this.setState({ expanded: true, content: content });
      }
    };

    _this2.handleExpand = function () {
      _this.setState({ expanded: true, content: _this.props.content });
    };

    _this2.state = {
      expanded: true,
      content: null
    };
    return _this2;
  }

  (0, _createClass3.default)(ReadMore, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleContentChange(this.props.content);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var content = _ref.content;

      if (this.props.content !== content) {
        this.handleContentChange(content);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          content = _state.content,
          expanded = _state.expanded;


      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          'p',
          null,
          content,
          !expanded && _react2.default.createElement(
            'a',
            { className: 'text--nowrap ml--', onClick: this.handleExpand },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'ReadMore.instructions',
              defaultMessage: 'read more'
            })
          )
        )
      );
    }
  }]);
  return ReadMore;
}(_react2.default.Component);

ReadMore.propTypes = {
  content: _propTypes2.default.string.isRequired,
  maximumSummaryLength: _propTypes2.default.number.isRequired
};